import _ from "lodash";

import ExternalLogger from "../logger/ExternalLogger";

var GroupService = function ($q, accountService, groupFactory) {
    var logger = ExternalLogger.getInstance("GroupService");

    var service = {};

    //Caching - Map that stores the indicators by group id
    var fevaValuesMap = {};
    //Indicator to determine if all groups have been checked for FEVA
    var allGroupsChecked = false;

    service.isSubjectToFEVA = function () {
        //Get the active group account
        var groupId = accountService.getActiveGroupAccount().groupId;
        var fevaInd = null;
        var deferred = $q.defer();

        //check if the active group account is in the cache
        var groupIndicator = _.find(fevaValuesMap, function (value, key) {
            return key === groupId;
        });

        //if value not in the map then call REST service
        if (groupIndicator) {
            deferred.resolve(groupIndicator);
        } else {
            service.callRESTService(groupId, deferred);
        }
        return deferred.promise;
    };

    service.isAnyGroupSubjectToFEVA = function () {
        //on the profile page, we need to check
        //if any of the plans are subject to FEVA
        var deferred = $q.defer();

        //are there any plans subject to FEVA in the cache
        var groupIndicator = _.find(fevaValuesMap, function (value, key) {
            return value === true;
        });

        if (groupIndicator) {
            deferred.resolve(true);
        } else {
            if (allGroupsChecked) {
                deferred.resolve(false);
            } else {
                service.callRESTService(null, deferred);
            }
        }

        return deferred.promise;
    };

    service.callRESTService = function (groupId, deferred) {
        groupFactory.isSubjectToFEVA(groupId).then(
            function success(response) {
                //populate the cache using the rest response
                _.each(response.indicators, function (item) {
                    fevaValuesMap[item.groupId] = item.indicator;
                });
                var foundGroupSubjectToFEVA = false;
                //are there any plans subject to FEVA in the cache
                var groupIndicator = _.find(fevaValuesMap, function (value, key) {
                    return value === true;
                });
                if (groupIndicator) {
                    foundGroupSubjectToFEVA = true;
                }
                if (groupId === null) {
                    allGroupsChecked = true;
                }
                deferred.resolve(foundGroupSubjectToFEVA);
            },
            function error(message) {
                deferred.resolve(false);
                logger.error(
                    "ERROR - groupFactory.isSubjectToFEVA(groupId): retrieving isSubjectToFEVA:" +
                        message
                );
            }
        );
    };

    return service;
};

GroupService.$inject = ["$q", "accountService", "groupFactory"];
export default GroupService;
